import { render } from "./DashboardLeftItem.vue?vue&type=template&id=c364fe1e&scoped=true"
import script from "./DashboardLeftItem.vue?vue&type=script&lang=js"
export * from "./DashboardLeftItem.vue?vue&type=script&lang=js"

import "./DashboardLeftItem.vue?vue&type=style&index=0&id=c364fe1e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c364fe1e"

export default script